import { render, staticRenderFns } from "./FinancesExpensesCategories.vue?vue&type=template&id=589b1dad&scoped=true"
import script from "./FinancesExpensesCategories.vue?vue&type=script&lang=js"
export * from "./FinancesExpensesCategories.vue?vue&type=script&lang=js"
import style0 from "./FinancesExpensesCategories.vue?vue&type=style&index=0&id=589b1dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b1dad",
  null
  
)

export default component.exports